import { Button, Col, Form, Input, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { useEffect, useState } from 'react';
import {
  NAME_REGEX,
  DEFAULT_COORDINATES,
  GUTTOR_SPACE,
  SAVE_PROFILE,
  // WEBSITE_REGEX,
  PHONE_NUMBER_REGEX,
  REQUEST_PAYLOAD,
  PIN_CODE_REGEX,
  GST_NO_REGEX,
  CONFIGURATION_VALIDATIONS,
} from '../../../../../shared/constants/commonConstants';
import {
  CityOption,
  HospitalProfileSaveRequest,
  LocationOption,
  StateOption,
} from '../../../../../shared/models/hospitalProfile.model';
import AllStateAutoComplete from '../../../shared/AllStateAutoComplete';
import CityAutoComplete from '../../../shared/CityAutoComplete';
import Map from '../../../shared/Map';
import { APPID } from './../../../../../shared/constants/commonConstants';
import SendRequest from './../../../../../shared/services/sendRequest.service';
import { FileDetail } from './../../../../../shared/models/file.profile.model';
import { success } from '../../../../../utils/utility';
import { error } from './../../../../../utils/utility';
import { fetchHospitalProfile } from '../../../../../store/actions/hospitalAction';
import { useDispatch } from 'react-redux';
import UploadImage from '../../../shared/UploadImage';
import ApplicationDetail from '../../../../../shared/services/applicationDetail.service';
import LocationAutoComplete from '../../../shared/LocationAutoComplete';
import _ from 'lodash';
import { PREFIXES } from '../../../../../shared/constants/crmConstants';

const SaveHospitalDetails = ({ data, onCancel, imgUrl }: any): any => {
  const [form] = Form.useForm();
  const [inputTextValue, setInputTextValue] = useState('');
  const [state, setState] = useState(null as any);
  const [city, setCity] = useState(null as any);
  const [isDefaultCity, setIsDefaultCity] = useState(true);
  const [latLong, setLatLong] = useState({ lat: null, lng: null } as any);
  const [fileData, setFileData] = useState({ fileGuid: '', fileName: '' });
  const [location, setLocation] = useState(null as any);
  const dispatch = useDispatch();
  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };
  useEffect((): any => {
    localStorage?.setItem('FileUploadType', 'Profile'); // upload image in profile section bugfix
    return (): any => {
      localStorage?.removeItem('FileUploadType');  // removing filetypes on unmounting of the component
    };
  }, []);

  const onCancelHandle = (): any => {
    onCancel();
  };
  const onSubmit = async (): Promise<void> => {
    const formData: any = form.getFieldsValue();
    if (latLong && latLong.lat && latLong.lng) {

      const requestPayload: HospitalProfileSaveRequest = {
        applicationId: APPID,
        profile: {
          id: ApplicationDetail.instance.getProfileId(),
          fullName: formData.hospName,
          displayName: formData.displayName,
          streetAddress: formData.address,
          supremeId: data?.supremeId,
          pincode: formData.pincode,
          gstNumber: formData?.gstNumber || null,
          stateId: state?.id || data?.stateId || 0,
          cityId: city?.id || data?.cityId || 0,
          rohiniId: data?.rohiniId || '0',
          tollfreeNumber: formData.supportNumber,
          landlineNumber: formData.landlineNumber,
          emailId: formData.emailId,
          latitude: latLong.lat,
          longitude: latLong.lng,
          description: formData.about,
          website: formData.website,
          isActive: true,
          locationId: location?.id || data?.locationId || 0,
          documentDetails: (fileData.fileName && fileData.fileGuid) ? [
            {
              id: 0,
              profileId: ApplicationDetail.instance.getProfileId(),
              typeName: 'Logo',
              docName: fileData.fileName,
              docId: fileData.fileGuid,
              description: 'Hospital logo',
              isActive: true,
            },
          ] : null as any,
        },
      };

      const saveProfileResponse = await SendRequest.instance.post(
        process.env.REACT_APP_BASE_URL + SAVE_PROFILE,
        requestPayload,
      );
      if (saveProfileResponse && saveProfileResponse.isSuccess) {
        dispatch(fetchHospitalProfile(REQUEST_PAYLOAD));
        success('Profile Saved Successfully');
        onCancelHandle();
      } else if (saveProfileResponse.errorMessage) {
        error(saveProfileResponse.errorMessage);
      } else {
        error('Profile Saved Failed.');
      }
    } else {
      error('Latitude or Longitude is missing.');
      return;
    }
  };
  useEffect((): void => {
    if (data && !_.isEmpty(data)) {
      setInitProfileData(data);
      setCity({ id: undefined, value: data?.city });
    }
    // eslint-disable-next-line
  }, [data]);

  const setInitProfileData = (profile: any): void => {
    form.setFieldsValue({
      hospName: profile.fullName,
      displayName: profile.displayName,
      about: profile.description,
      emailId: profile.emailId,
      website: profile.website,
      landlineNumber: profile.landlineNumber,
      supportNumber: profile.tollfreeNumber,
      pincode: profile.pincode,
      gstNumber: profile?.gstNumber?.toUpperCase(),
      city: profile.city,
      state: profile.state,
      location: profile.location,
    });
    setInputText(profile.streetAddress);
    setLatLong({ lat: profile.latitude, lng: profile.longitude });
    if (profile.documentDetails && profile.documentDetails.length > 0) {
      const logoList = profile.documentDetails.filter(
        (doc: any): boolean => doc.typeName === 'Logo',
      );
      if (logoList && logoList.length > 0) {
        setFileData({
          fileGuid: logoList[0].docId,
          fileName: logoList[0].docName,
        });
      }
    }
  };
  const changeToUpper = (event: any): void => {
    form.setFields([
      {
        name: event?.target?.id,
        value: event?.target?.value.toUpperCase(),
      },
    ]);
  };
  const setInputText = (text: string): void => {
    setInputTextValue(text);
    form.setFieldsValue({ address: text });
  };

  const setPincode = (pin: string): void => {
    form.setFieldsValue({ pincode: pin });
  };

  const onStateSelect = (stateInfo: StateOption): void => {
    setState(stateInfo);
    form.setFieldsValue({
      city: '',
      location: '',
      state: stateInfo?.value,
    });
  };

  const onCitySelect = (cityInfo: CityOption): void => {
    setCity(cityInfo);
    form.setFieldsValue({
      city: cityInfo?.value,
      location: '',
    });
  };

  const getLatLng = (latlng: any): void => {
    setLatLong(latlng);
  };

  const getFiles = ([{ fileName, fileGuid }]: FileDetail[]): void => {
    setFileData({ fileName, fileGuid });
  };

  const onSelectEvent = (): void => {
    setCity(null);
    setIsDefaultCity(false);
    form.setFieldsValue({
      city: '',
      location: '',
    });
  };

  const onLocationSelect = (locationInfo: LocationOption): void => {
    setLocation(locationInfo);
    form.setFieldsValue({
      location: locationInfo?.value,
    });
  };

  return (
    <div>
      <Form form={form} {...layout} onFinish={onSubmit} className="add-profile-form">
        <Row gutter={GUTTOR_SPACE} align="middle">
          <Col md={12}>
            <Row>
              <Col md={24}>
                <Form.Item
                  name="hospName"
                  label="Hospital Name"
                  rules={[
                    { required: true, pattern: NAME_REGEX, message: 'Please Type Valid Hospital Name' },
                  ]}
                >
                  <Input
                    placeholder="Hospital Name"
                    className="text-capitalize"
                  />
                </Form.Item>
              </Col>
              <Col md={24} className="text-center">
                <Form.Item
                  name="displayName"
                  label="Hospital Display Name"
                  rules={[
                    { required: true, pattern: NAME_REGEX, message: 'Please Type Valid Hospital Display Name' },
                  ]}
                >
                  <Input
                    placeholder="Display Name"
                    className="text-capitalize"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col md={12} className="text-center">
            <UploadImage getFiles={getFiles} imageUrl={imgUrl} />
          </Col>
        </Row>
        <Row gutter={GUTTOR_SPACE}>
          <Col span={24}>
            <Form.Item
              name="about"
              label="About"
              rules={[{ required: true }, { message: 'Please Type About' }]}
            >
              <TextArea
                rows={4}
                placeholder="About"
                className="text-capitalize scrollbar"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={GUTTOR_SPACE}>
          <Col span={12}>
            <Form.Item
              name="emailId"
              label="Email ID"
              rules={[
                { required: true, type: 'email' },
                { message: CONFIGURATION_VALIDATIONS.emailIdValidation },
                { max: 50, message: CONFIGURATION_VALIDATIONS.emailIdCharLimit},
              ]}
            >
              <Input placeholder="Emall ID" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="website"
              label="Website"
            // rules={[{
            //   required: true, pattern: WEBSITE_REGEX, message: 'Website url is not valid',
            // }]}
            >
              <Input placeholder="Website" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={GUTTOR_SPACE}>
          <Col span={12}>
            <Form.Item
              name="landlineNumber"
              label="Mobile No."
              rules={[
                { pattern: PHONE_NUMBER_REGEX, message: 'Mobile No. is not valid' },
              ]}
            >
              <Input prefix={PREFIXES.MOBILE} placeholder="Mobile No." maxLength={10} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="supportNumber" label="Customer Support No.">
              <Input placeholder="Customer support No." />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={GUTTOR_SPACE}>
          <Col span={24}>
            <Form.Item name="address" label="Street Address">
              <TextArea
                rows={4}
                placeholder="Address"
                value={inputTextValue}
                onChange={(e: any): void => setInputText(e.target.value)}
                className="scrollbar"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={GUTTOR_SPACE}>
          <Col span={12}>
            <Form.Item name="state" label="State" rules={[{ required: true, message: 'State is required' }]}>
              <AllStateAutoComplete
                dValue={data?.state}
                onStateSelect={onStateSelect}
                onSelectEvent={onSelectEvent}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="city" label="City" rules={[{ required: true, message: 'City is required' }]}>
              <CityAutoComplete
                dValue={!isDefaultCity ? null : data?.city}
                onCitySelect={onCitySelect}
                stateId={!isDefaultCity ? state?.id : null}
                city={data?.city}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="location" label="Location" rules={[{ required: true, message: 'Location is required' }]}>
              <LocationAutoComplete
                onLocationSelect={onLocationSelect}
                location={!isDefaultCity ? null : data?.location}
                cityId={city?.id}
                city={!isDefaultCity ? null : city?.value}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="pincode"
              label="Pin code"
              rules={[
                { pattern: PIN_CODE_REGEX, message: 'Please Enter 6 digits', required: true },
              ]}
            >
              <Input placeholder="Pin code"/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="gstNumber"
              label="Gst Number"
              rules={[
                { pattern: GST_NO_REGEX, message: 'Please Enter a Valid GST No.', required: true },
              ]}
            >
             <Input placeholder="GST Number" maxLength={15} onChange={(e: any): any => changeToUpper(e)}/>
            </Form.Item>
          </Col>
        </Row>
        {latLong && (
          <Row style={{ height: '300px' }} className="mb-lg">
            <Col md={24}>
              <Map
                lat={+latLong.lat || DEFAULT_COORDINATES.lat}
                lng={+latLong.lng || DEFAULT_COORDINATES.lng}
                inputTextValue={inputTextValue}
                setPincode={setPincode}
                getLatLng={getLatLng}
                setInputTextAsAddress={setInputText}
                zoom={11.5}
                searchBox={true}
                containerElement={<div className="w-100 h-100" />}
                mapElement={<div className="w-100 h-100" />}
              />
            </Col>
          </Row>
        )}
        <Row gutter={GUTTOR_SPACE}>
          <Col md={24} className="text-right">
            <Button className="btn-cancel" onClick={onCancelHandle}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SaveHospitalDetails;
